<template>
    <div id="main-content">
        <div class="top-block">
            <div class="selected-item">
                <div>
                    <span class="title">&nbsp;</span>
                </div>
                <user-info></user-info>
            </div>

            <div class="tabs">
                <div class="tab">Пульт</div>
            </div>
        </div>
        <div class="tab-content" style="padding: 0">
            <p class="unable-text fw400">Выберите помещение</p>
        </div>
    </div>
</template>

<style scoped>
    .unable-text{
        font-size: 16px;
        line-height: 25px;
        padding: 50px 0;
        text-align: center;
        color: #979797;
    }
    .tab {
        cursor: not-allowed !important;
    }
</style>

<script>
    import {connectionState} from '../../../other/consts'
    import userInfo from '../other/topUserInfo'

    export default {
        components:{
            userInfo,
        },
        data() {
            return {
                connectionState,
            }
        },
    }
</script>
